import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen">
      <section className="relative pt-40 pb-24 overflow-hidden bg-[#1B2A4A]">
        <div className="absolute inset-0 bg-[#4A6FA5]/10" />
        <div className="relative mx-auto max-w-6xl px-5 lg:px-6">
          <div className="flex justify-center">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#B8860B]/40 bg-[#B8860B]/10 px-4 py-1.5 mb-8">
              <span className="text-sm font-semibold text-[#B8860B]">Privacy Policy</span>
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-[3.3rem] font-bold text-center text-[#F5F3EF] leading-tight">
            プライバシーポリシー
          </h1>
        </div>
      </section>

      <section className="py-16 lg:py-20 bg-[#F5F3EF]">
        <div className="mx-auto max-w-3xl px-5 lg:px-6">
          <p className="text-[#5A6577] mb-8 text-justify leading-relaxed">
            株式会社Senrigan（以下、「当社」）は、個人情報の保護に関する法律（以下、「個人情報保護法」）に基づき、以下のプライバシーポリシーを定め、個人情報の適切な取り扱いに努めます。
          </p>

          <h2 className="text-xl font-bold text-[#2D3748] mt-10 mb-4">1. 収集する個人情報</h2>
          <p className="text-[#5A6577] mb-3">当社は、以下の個人情報を収集することがあります：</p>
          <ul className="list-disc ml-6 text-[#5A6577] space-y-2">
            <li>氏名</li>
            <li>メールアドレス</li>
            <li>電話番号</li>
            <li>住所</li>
            <li>会社名・所属部署</li>
            <li>ウェブサイトの利用状況</li>
            <li>IPアドレス</li>
            <li>Cookie情報</li>
          </ul>

          <h2 className="text-xl font-bold text-[#2D3748] mt-10 mb-4">2. 個人情報の利用目的</h2>
          <p className="text-[#5A6577] mb-3">収集した個人情報は、以下の目的で利用します：</p>
          <ul className="list-disc ml-6 text-[#5A6577] space-y-2">
            <li>お問い合わせへの対応</li>
            <li>サービスの提供、維持、改善</li>
            <li>新サービスや更新情報のご案内</li>
            <li>契約の履行</li>
            <li>法令に基づく対応</li>
          </ul>

          <h2 className="text-xl font-bold text-[#2D3748] mt-10 mb-4">3. 個人情報の第三者提供</h2>
          <p className="text-[#5A6577] mb-3">当社は、以下のいずれかに該当する場合を除き、個人情報を第三者に提供いたしません：</p>
          <ul className="list-disc ml-6 text-[#5A6577] space-y-2">
            <li>お客様の同意がある場合</li>
            <li>法令に基づく場合</li>
            <li>人の生命、身体または財産の保護のために必要な場合</li>
            <li>公衆衛生の向上または児童の健全な育成の推進のために必要な場合</li>
            <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
          </ul>

          <h2 className="text-xl font-bold text-[#2D3748] mt-10 mb-4">4. 個人情報の安全管理</h2>
          <p className="text-[#5A6577] mb-3">当社は、個人情報の漏洩、滅失またはき損を防止するため、適切なセキュリティ対策を実施します：</p>
          <ul className="list-disc ml-6 text-[#5A6577] space-y-2">
            <li>アクセス制御の実施</li>
            <li>セキュリティソフトウェアの利用</li>
            <li>社員教育の実施</li>
            <li>情報セキュリティに関する社内規程の整備</li>
          </ul>

          <h2 className="text-xl font-bold text-[#2D3748] mt-10 mb-4">5. 個人情報の開示・訂正・利用停止</h2>
          <p className="text-[#5A6577] text-justify leading-relaxed">
            保有個人データについて、開示、訂正、利用停止等を請求される場合は、下記の連絡先までご連絡下さい。
          </p>

          <h2 className="text-xl font-bold text-[#2D3748] mt-10 mb-4">6. Cookieの使用について</h2>
          <p className="text-[#5A6577] text-justify leading-relaxed">
            当社ウェブサイトでは、利便性向上のためCookieを使用しています。Cookieの使用を望まない場合は、ブラウザの設定で無効化することができます。
          </p>

          <h2 className="text-xl font-bold text-[#2D3748] mt-10 mb-4">7. プライバシーポリシーの改定</h2>
          <p className="text-[#5A6577] text-justify leading-relaxed">
            本プライバシーポリシーは、法令変更や事業内容の変更に応じて、予告なく改定することがあります。
          </p>

          <h2 className="text-xl font-bold text-[#2D3748] mt-10 mb-4">8. お問い合わせ窓口</h2>
          <p className="text-[#5A6577] mb-4">個人情報の取扱いに関するお問い合わせは、下記までご連絡下さい：</p>
          <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6">
            <p className="text-[#5A6577]">
              株式会社Senrigan 個人情報保護管理者<br />
              〒731-0137<br />
              広島県広島市安佐南区山本2-3-35<br />
              TEL：082-209-0181<br />
              受付時間：平日10:00～17:00
            </p>
          </div>

          <p className="text-[#7B8794] mt-10 text-sm">制定日：2025年7月1日</p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
